import { useEffect, useState } from 'react';
import { get, post } from '../../Services/api';
import './AdminIngredientsMerge.css'
import AdminIndividualIngredient from './IndividualIngredient/IndividualIngredient';
import loading_display from '../../Utility/loading_display';
import SelectedIngredientModal from './SelectedIngredientModal/SelectedIngredientModal';
import { Tooltip } from 'react-tooltip';
import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AdminIngredientsMerge({ user_data }) {

    const navigate = useNavigate();
    const query = useQuery();
    const page_num = query.get('page');

    const [ingredient, setIngredient] = useState()
    const [ingredients, setIngredients] = useState()
    const [page, setPage] = useState(page_num ? page_num : 1)
    const [condition, setCondition] = useState('')

    useEffect(() => {
        // get ingredients
        getAllIngredients()
    }, [condition, page])


    async function getAllIngredients() {
        try {
            // page number limit offset
            const offset = 20 * (page - 1)
            const response = await get('/api/admin/ingredient/get-all-similar-ingredients?offset=' + offset)
            console.log(response)
            if (response)
                setIngredients(response)
            else
                setIngredients([])
        } catch (error) {
            console.log('error getting attention needed ingredients')
        }
    }


    function searchFunc(value) {
        if (value)
            setCondition(` AND i.name ILIKE '%${value}%'`)
        else
            setCondition()
    }

    function setPageFunc(newPage) {
        navigate('/admin/ingredients/merge?page=' + newPage);
        // Change page
        setPage(newPage)
    }

    return (
        <div className='admin_ingredients'>
            <div className='admin_ingredients_div'>
                <div className='admin_ingredients_page_div text_align_center'>
                    <div className='flex gap_6 width_fit_content'>
                        {page > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPageFunc(parseInt(page) - 1)}>{'<'}</p> : null}
                        <p className='font_size_16 cursor_default'>{page}</p>
                        {ingredients && ingredients.length > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPageFunc(parseInt(page) + 1)}>{'>'}</p> : null}
                    </div>
                    <p>page</p>
                </div>

                <input className='add_meal_search_box font_family_inter font_size_14' placeholder='Search Ingredient...' onChange={(e) => searchFunc(e.target.value)} />

                <div className='flex gap_20 width_100'>
                    <div className={'flex flex_column ' + (!ingredient ? 'width_100' : '')}>
                        <div className={(!ingredient ? 'admin_ingredients_list_indiv_ingredient' : 'admin_ingredients_list_indiv_ingredient_small')}>
                            <div></div>

                            <p className='font_size_16'>Image</p>
                            <p className='font_size_16'>Name</p>
                            {!ingredient ? <p className='font_size_16'>Restrictions</p> : null}
                            {!ingredient ? <p className='font_size_16'>Cost</p> : null}
                            {!ingredient ? <p className='font_size_16'>Unit</p> : null}
                            {!ingredient ? <p className='font_size_16'>Cal</p> : null}
                            {!ingredient ? <p className='font_size_16'>Carb</p> : null}
                            {!ingredient ? <p className='font_size_16'>Fat</p> : null}
                            {!ingredient ? <p className='font_size_16'>Protein</p> : null}
                        </div>
                        {ingredients?.map((ingredient_tmp, i) => (
                            <div key={i} className={(!ingredient ? 'admin_ingredients_list_indiv_ingredient' : 'admin_ingredients_list_indiv_ingredient_small') + ' admin_ingredients_list_indiv_ingredient_' + ((!ingredient || ingredient.ingredient_id != ingredient_tmp.ingredient_id) ? i % 2 : 'clicked')}>
                                <div></div>

                                {ingredient_tmp.image ? <img src={ingredient_tmp.image} className='admin_ingredients_list_indiv_ingredient_img' /> : <div></div>}

                                <p className='font_size_18 font_weight_600 word_break cursor_pointer' onClick={() => setIngredient(ingredient_tmp)}>{ingredient_tmp.name}</p>

                                {!ingredient ? <p className='font_size_16 word_break'>{ingredient_tmp.restriction}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>${parseFloat(ingredient_tmp.cost).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{ingredient_tmp.unit_name}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.calories).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.carb).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.fat).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.protein).toFixed(2)}</p> : null}

                                <Tooltip id={ingredient_tmp.ingredient_id + "-need-attention-tooltip"} />
                            </div>
                        ))}
                    </div>

                    {ingredient ? <AdminIndividualIngredient ingredient={ingredient} setIngredient={setIngredient} getIngredient={getAllIngredients} user_data={user_data} /> : null}
                </div>
            </div>
        </div>
    );
}


export default AdminIngredientsMerge;